import React from "react";
import ReactDOM from "react-dom";

// import * as serviceWorker from "./serviceWorker";
import TrainingExtension from "./TrainingViews/TrainingExtension";
import HomePageExtention from "./Home/HomePageExtention";
import HorsePageExtention from "./AddEditHorse/HorsePageExtention";
import MultimediaMobileHelper from "./Multimedia/MultimediaMobileHelper";
import { SideMenuExtention } from "./Menu/SideMenu";
import Report from "./Report/Report";
import RiderRole from "./RiderRole/RiderRole";
import Sharing from "./SharingPage/SharingPage";
import TrainingPopup from "./TrainingPopup/TrainingPopup";
import SharePage from "./SharingPage/SharePage";
import AutoCreateTaskPage from "./AutoCreateTask/AutoCreateTaskPage";
import VaccinationPopup from "./Home/VaccinationView/VaccinationPopup";
import PriceReport from "./Home/Settings/PriceReport";
import DewormingTypes from "./Home/Settings/DewormingTypes";
import ReportSettings from "./Report/ReportSettings";
import MultimediaHelper from "./Multimedia/MultimediaHelper";
import SendSalesData from "./SendSalesData/SendSalesData";
import { PublicHorsePresentationHolder } from "./SendSalesData/SendSalesData";
import FieldManager from "./FieldManager/FieldManager";
import WalkerManager from "./WalkerManager/WalkerManager";
import HealthStatusManager from "./HealthStatusManager/HealthStatusManager";
import VeterinarianManager from "./VeterinarianManager/VeterinarianManager";
import GeneralTaskPanelsManagerHolder from "./GeneralTaskPanelsManager/GeneralTaskPanelsManager";
import SharedFilesPage from "./SharedFilesView/SharedFilesView";
import GlobalMultimediaHelper from "./Multimedia/GlobalMultimediaHelper";

// at the top of index.js, after your existing globals:
const ShareExtension =
  window.Capacitor &&
  window.Capacitor.Plugins &&
  window.Capacitor.Plugins.ShareExtension;

function initShareHandling() {
  if (!ShareExtension) {
    console.warn("ShareExtension plugin not available");
    return;
  }

  // 1) Cold start: were we launched via a share?
  ShareExtension.checkSendIntentReceived()
    .then((res) => {
      if (res && Array.isArray(res.payload) && res.payload.length) {
        handleSharedFiles(res.payload);
        // on Android you *must* finish the intent or it will re-fire on next resume
        ShareExtension.finish();
      }
    })
    .catch((err) => console.error("share check failed", err));

  // 2) Warm start: listen for new ones
  window.addEventListener("sendIntentReceived", async () => {
    try {
      const res = await ShareExtension.checkSendIntentReceived();
      if (res && Array.isArray(res.payload) && res.payload.length) {
        handleSharedFiles(res.payload);
        ShareExtension.finish();
      }
    } catch (e) {
      console.error("share event failed", e);
    }
  });
}

// your handler – show the sharing page and render the React component
function handleSharedFiles(payload) {
  // stash globally if you need elsewhere
  window._sharedFiles = payload;

  // navigate to your page
  window.location.hash = "#sharedFilesPage";

  document.getElementById("sharedFilesPage").style.display = "block";
  // mount your React list into the container
  const container = document.getElementById("shared-files-root");
  container.style.height = "100%"; // set height to 100%
  if (container) {
    ReactDOM.render(
      React.createElement(SharedFilesPage, { initialFiles: payload }),
      container
    );
  } else {
    console.warn("No #shared-files-root container found");
  }
}

// … inside your existing onDeviceReady() or init() …
function onDeviceReady() {
  // … all your old setup …

  // add this line at the end of onDeviceReady:
  initShareHandling();
}

// and make sure deviceready actually fires it:
document.addEventListener("deviceready", onDeviceReady, false);

window.trainingExtension = new TrainingExtension();
window.HomePage.extention = new HomePageExtention();
window.Managers.extention = new HorsePageExtention();
window.multimediaMobileHelper = new MultimediaMobileHelper();
window.globalMultimediaHelper = new GlobalMultimediaHelper();
// window.multimediaHelper = new MultimediaHelper();
window.TopMenu.Self.sidebarExtention = new SideMenuExtention();
window.vetfartable.extention = new Report();
window.sendSalesData = new SendSalesData();
window.fieldManager = new FieldManager();
window.healthStatusManager = new HealthStatusManager();
window.generalTaskPanelsManager = new GeneralTaskPanelsManagerHolder();
window.walkerManager = new WalkerManager();
window.showPublicPresentation = new PublicHorsePresentationHolder();
window.window.managers = new RiderRole();
window.managers.extention = new Sharing();
window.TrainingPopup = TrainingPopup;
window.SharePage = SharePage;
window.AutoCreateTaskPage = AutoCreateTaskPage;
window.VaccinationPage.extention = new VaccinationPopup();
window.managers.priceReport = new PriceReport();
window.managers.dewormingTypes = new DewormingTypes();
window.managers.reportSettings = new ReportSettings();
